import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    DELETE_TEMPLATE_FAILURE,
    DELETE_TEMPLATE_SUCCESS,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';
import { getDetailedProductTemplateList } from 'src/pages/scheduleSurgery/redux/actions';

import { deleteTemplateService } from 'src/pages/more/pages/templates/redux/services/index.js';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* deleteTemplates(action) {
    try {
        const result = yield deleteTemplateService(action.payload);
        yield put({ type: DELETE_TEMPLATE_SUCCESS, payload: result });

        // Get current search parameters to refresh the list with same filters
        const { searchAppliedObject, filterParams } = yield select((state) => ({
            searchAppliedObject: state.commonTemplateReducer.searchAppliedObject || {},
            filterParams: {
                pageNum: state.productTemplatesReducer.detailedProductTemplateList.pagination.pageNum || 0,
                pageLimit: state.productTemplatesReducer.detailedProductTemplateList.pagination.pageLimit || 50,
                templateSubCategoryCode: state.productTemplatesReducer.detailedProductTemplateList.templateSubCategoryCode || ''
            }
        }));

        // Prepare all search parameters
        const searchParams = {
            templateNameSearch: searchAppliedObject?.templateName,
            physicianSearch: searchAppliedObject?.physicianName,
            accountNoList: searchAppliedObject?.AccountNameNo,
            accountSearch: searchAppliedObject?.AccountNameNo,
            startDateSearch: searchAppliedObject?.createdStartDate,
            endDateSearch: searchAppliedObject?.createdEndDate,
            productNumberSearch: searchAppliedObject?.itemOrSetNumber
        };

        // Remove undefined values
        const cleanSearchParams = Object.fromEntries(
            Object.entries(searchParams).filter(([_, value]) => value !== undefined && value !== '')
        );

        // Refresh the template list to update the total count
        yield put(getDetailedProductTemplateList({
            ...filterParams,
            ...cleanSearchParams
        }));
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/order/templates/${action.payload}`,
            requestPayload: action.payload,
        });
        yield put({
            type: DELETE_TEMPLATE_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
